<template>
  <div class="my-promotion">
    <div class="header">
      <div class="name acea-row row-center-wrapper">
        <div>当前佣金</div>
        <router-link class="record" :to="'/user/cashrecord'">
          提现记录<span class="iconfont icon-xiangyou"></span>
        </router-link>
      </div>
      <div class="num">{{ userInfo.brokerage_price || 0 }}</div>
      <!-- <div class="proxy" v-if="userInfo.is_agent == 0 && userInfo.agent_status == 0">
        <router-link class="proxy_child" :to="'/user/user_form'">
          申请成为代理
        </router-link>
      </div> -->
      <div class="proxy" v-if="userInfo.agent_range != null && isAgent">
        <p class="proxy_child">{{showRangeprovince}} {{showRangeCity}}</p>
      </div>
      <!-- <div class="superior" v-if="userInfo.agent_uid != 0 || userInfo.spread_uid != 0">
        <span v-if="userInfo.agent_uid != 0">代理上级：{{userInfo.agent_name}}</span>
        &nbsp;
        <span v-if="userInfo.spread_uid != 0">推广上级：{{userInfo.spread_name}}</span>
      </div>
      <div class="superior" v-else>
        <span>上级：追觅专业版吹风机</span>
      </div> -->
      <div class="profit acea-row row-between-wrapper">
        <div class="item">
          <div>昨日收益</div>
          <div class="money">{{ userInfo.yesterDay || 0 }}</div>
        </div>
        <div class="item">
          <div>累积已提</div>
          <div class="money">{{ userInfo.extractTotalPrice || 0 }}</div>
        </div>
      </div>
    </div>
    <div class="bnt btn-bg-color" @click="toCash">立即提现</div>
    <!-- ackerman   推广码 -->
    <!-- <div class="promot_Code" v-if="userInfo.is_agent == 1 && userInfo.agent_status == 1">
      <div class="promot_Code_child">
          <div class="promot_Code_title"> 我的推广码 </div>
          <div class="promote_Code_con"> {{userInfo.agent_code}} </div>
          <div class="promote_Code_copy" :data-clipboard-text="userInfo.agent_code" @click="promoteCopy()"> 复制 </div>
      </div>
    </div> -->
    <div class="list acea-row row-between-wrapper list-padding-bottom">
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/poster'"
      >
        <span class="iconfont icon-erweima"></span>
        <div>推广名片</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_list'"
      >
        <span class="iconfont icon-tongji"></span>
        <div>推广人统计</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission'"
      >
        <span class="iconfont icon-qiandai"></span>
        <div>佣金记录</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_order'"
      >
        <span class="iconfont icon-dingdan"></span>
        <div>佣金订单</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_rank'"
      >
        <span class="iconfont icon-paihang1"></span>
        <div>推广人排行</div>
      </router-link>
      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission/rank'"
      >
        <span class="iconfont icon-paihang"></span>
        <div>佣金排行</div>
      </router-link>
      <!-- <router-link
        v-if="userInfo.is_agent == 1"
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_offlinecommission'"
        
      >
        <span class="iconfont icon-yongjin"></span>
        <div>线下推广佣金</div>
      </router-link> -->
      <!-- <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/news_list'"
      >
        <span class="iconfont-video icon-video"></span>
        <div>视频专区</div>
      </router-link> -->
      <!-- <router-link
        v-if="userInfo.agent_range === null"
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promotion/city_agent_form?type=city'"
      >
        <span class="iconfont icon-shenqingguanli"></span>
        <div>城市盟主申请</div>
      </router-link>
      <router-link
        v-if="userInfo.agent_range == 'city' || userInfo.agent_range === null"
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promotion/city_agent_form?type=province'"
      >
        <span class="iconfont icon-shenqing"></span>
        <div>省级盟主申请</div>
      </router-link> -->
      <router-link
        v-if="userInfo.agent_range == 'province' && isAgent"
        class="item acea-row row-center-wrapper row-column"
        :to="`/user/promotion/agent_application_list?type=${userInfo.agent_range}`"
      >
        <span class="iconfont icon-lingliaoshenqingliebiao"></span>
        <div>代理审核列表</div>
      </router-link>
      <router-link
        v-if="(userInfo.agent_range == 'city' || userInfo.agent_range == 'province') && isAgent"
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promotion/promoter_applylist'"
      >
        <span class="iconfont icon-baoxiaoshenqing"></span>
        <div>分销审核列表</div>
      </router-link>
      <router-link
        v-if="(userInfo.agent_range == 'city' || userInfo.agent_range == 'province') && isAgent"
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/scancode/rank'"
      >
        <span class="iconfont icon-tianjiayonghu"></span>
        <div>代理推广排行</div>
      </router-link>
      <router-link
        v-if="(userInfo.agent_range == 'city' || userInfo.agent_range == 'province') && isAgent"
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/sales_volume/rank'"
      >
        <span class="iconfont icon-xiaoshou"></span>
        <div>代理销量排行</div>
      </router-link>
      <router-link
        v-if="(userInfo.agent_range == 'city' || userInfo.agent_range == 'province') && isAgent"
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/salesamount_rank'"
      >
        <span class="iconfont icon-xiaoshouyuce"></span>
        <div>代理收益排行</div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { getUser } from "../../../api/user";
import ClipboardJS from "clipboard";

import "@assets/iconfont-custom/iconfont.css";

export default {
  name: "UserPromotion",
  components: {},
  props: {},
  data: function() {
    return {
      userInfo: {},
    };
  },
  watch: {
    $route(n) {
      if (n.name == "UserPromotion") this.getInfo();
    }
  },
  mounted: function() {
    this.getInfo();
  },
  methods: {
    getInfo: function() {
      let that = this;
      getUser().then(
        res => {
          that.userInfo = res.data;
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    toCash: function() {
      this.$router.push({ path: "/user/user_cash" });
    },
    promoteCopy: function () {
      let copybtn = document.getElementsByClassName("promote_Code_copy");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
      });
    }
  },
  computed:{
    showRangeprovince(){
      if(this.userInfo.agent_range == null || this.userInfo.agent_range == "city") return;
      let showRangeprovince = `${this.userInfo.agent_province} 省级盟主`;
      return showRangeprovince
    },
    showRangeCity(){
      if(this.userInfo.agent_range == null) return;
      return `${this.userInfo.agent_city} 城市盟主`
    },
    isAgent(){
      let userInfo = this.userInfo
      let timestamp = Math.round(new Date().getTime()/1000).toString();
      let agentExpireTime = userInfo.agent_expire_time;
      if(userInfo.is_agent == 1 && userInfo.agent_status == 1 &&
        agentExpireTime >= timestamp
      ){
        return true
      }else{
        return false
      }
      // if(agentExpireTime >= timestamp){return true}else{return false}
    }
  }
};
</script>
<style scoped>
  .proxy {
    width: 100%;
    text-align: center;
    margin-top: .1rem;
  }
  .proxy_child {
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    line-height: 1em;
    /* text-decoration: underline; */
    /* margin-bottom: .1rem */
  }
  .promot_Code {
    width: 100%;
    padding: 0.3rem 0.2rem 0;
  }
  .promot_Code_child {
    width: 100%;
    background: #ffffff;
    box-sizing: border-box;
    line-height: 2.2em;
    font-size: 16px;
    border-radius: 1em;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.4em;
  }
  .promot_Code_title{
    width: 7em;
    background: #d2ac72;
    color: #ffffff;
    text-align: center;
  }
  .promote_Code_con {
    max-width: 12em;
    display: block;
    font-size: 14px;
    text-align: center;
    color: #d2ac72;
  }
  .promote_Code_copy{
    font-size: 14px;
    color: #909090;
    padding: 0 1em;
    background: #fafafa;
    text-align: center;
  }
  .btn-bg-color{
    background: #f85141;
    color: #ffddb9!important;
  }
  .my-promotion .header{
    height: 4.1rem;
  }
  .superior{
    text-align: center;
    white-space:nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: .2rem .3rem 0;
    color: #fff;
    font-size: .28rem;
    font-weight: 400;
  }
  .superior span{
    color: #fff;
  }
</style>